"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: heroRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section ref={heroRef} className="relative w-full h-screen overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay muted loop playsInline className="w-full h-full object-cover">
          <source src="/img/hero_drone_flight.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute inset-0 bg-dark-background/70" />
      </div>

      {}
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-4 sm:px-6 lg:px-8">
        <div className={`max-w-4xl mx-auto text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          {}
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-display font-bold text-foreground mb-6 sm:mb-8">
            Precision Aerial Intelligence for Your Projects
          </h1>

          {}
          <p className="text-lg sm:text-xl md:text-2xl text-foreground mb-8 sm:mb-12 max-w-2xl mx-auto">
            Advanced drone services delivering real-time data, thermal imaging, and comprehensive mapping solutions across Central Texas and DFW Metroplex
          </p>

          {}
          <Link to="/ServicesPage">
            <Button size="lg" className="text-base sm:text-lg px-8 py-6 shadow-strong hover:scale-105 hover:shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
              Explore Our Services
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}